import { api } from '@/lib/customFetch'
import type { UserDetail, UserListResult, InviteUserInput, UpdateUserInput } from '@/lib/types/ged'

export type ListUsersParams = {
  search?: string
  status?: 'active' | 'inactive' | 'all'
  profileIds?: string[]
  sort?: 'lastLogin' | 'name'
  page?: number
  pageSize?: number
}

export const userKeys = {
  all: () => ['admin-users'] as const,
  list: (params: ListUsersParams) => ['admin-users', 'list', params] as const,
  detail: (id: string) => ['admin-users', 'detail', id] as const,
}

function buildQuery(params: ListUsersParams): string {
  const q = new URLSearchParams()
  if (params.search)   q.set('search', params.search)
  if (params.status)   q.set('status', params.status)
  if (params.sort)     q.set('sort', params.sort)
  if (params.page)     q.set('page', String(params.page))
  if (params.pageSize) q.set('pageSize', String(params.pageSize))
  params.profileIds?.forEach(id => q.append('profileIds', id))
  const qs = q.toString()
  return qs ? `?${qs}` : ''
}

export function listUsers(params: ListUsersParams = {}): Promise<UserListResult> {
  return api.get<UserListResult>(`/admin/users${buildQuery(params)}`)
}

export function getUser(id: string): Promise<UserDetail> {
  return api.get<UserDetail>(`/admin/users/${id}`)
}

export function inviteUser(input: InviteUserInput): Promise<UserDetail> {
  return api.post<UserDetail>('/admin/users/invite', input)
}

export function updateUser(id: string, input: UpdateUserInput): Promise<UserDetail> {
  return api.put<UserDetail>(`/admin/users/${id}`, input)
}

export function deactivateUser(id: string): Promise<void> {
  return api.post<void>(`/admin/users/${id}/deactivate`, {})
}

export function activateUser(id: string): Promise<void> {
  return api.post<void>(`/admin/users/${id}/activate`, {})
}

export function adminResetPassword(id: string): Promise<void> {
  return api.post<void>(`/admin/users/${id}/reset-password`, {})
}

export function adminResetMfa(id: string): Promise<void> {
  return api.post<void>(`/admin/users/${id}/reset-mfa`, {})
}
